export const COLUMNS_OFFSET = 5;
